export const FIELD = 'field'
export const VALUE = 'value'

export default {
  FIELD,
  VALUE,
}